module.exports = __webpack_public_path__ + "img/AR.18d27ecf.png";